<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponente
        :aplica-busqueda-fecha="true"
      :icono="icono"
      :titulo="titulo"
      :codigoTitulo="codigoTitulo"
      :subTitulo="subTitulo"
      :cifrasControl="cifrasControl"
      :datosTabla="datosTabla"
      :resource="resource"
      @_funcionExtra="getObtenerDatosBandeja"
      @_actualizaFecha="actualizarFecha"
    ></BandejaComponente> 
  </div>
</template>

<script>
import BandejaComponente from "../components/bandejas/BandejaComponente.vue";
import Swal from "sweetalert2";

export default {
  name: "bandejaCobro",
  components: {
    BandejaComponente,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fechaFin: "",
    fechaIncio: "",
    idEmpleado: null,
    idClinica: null,
    idUsuario: null,
    idPaciente: 0,
    datosTabla: [],
    encabezadosPendientes: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },

      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacienteCobroComponente",
      }, 
      {
        key: "dtefechaAlta",
        label: "Fecha Finalización M2",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtefechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador M2",
        sortable: true, 
      },  
      {
        key: "idPti",
        label: "Id PTI",
        sortable: true, 
      },  
    ],
    encabezadosEnproceso: [
           {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },

      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacienteCobroComponente",
      }, 
      {
        key: "dtefechaAlta",
        label: "Fecha Finalización M2",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtefechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador M2",
        sortable: true, 
      },  
      {
        key: "idPti",
        label: "Id PTI",
        sortable: true, 
      },  
    ],
    encabezadosFinalizados: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },

      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true, 
      }, 
      {
        key: "dtefechaAlta",
        label: "Fecha Finalización M2",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtefechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador M2",
        sortable: true, 
      },  
      {
        key: "idPti",
        label: "Id PTI",
        sortable: true, 
      },  
    ],

    cifrasControl: [
      {
        id: 1,
        nombre: "Pendientes",
        cantidad: 0,
        icono: "star",
        layoutTabla: [],
      },
      {
        id: 2,
        nombre: "En proceso",
        cantidad: 0,
        icono: "star-half",
        layoutTabla: [],
      },
      {
        id: 3,
        nombre: "Finalizados",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
      },
    ],
    icono: "fa fa-credit-card",
    titulo: "EMBAJADOR",
    codigoTitulo: "BJ_01_HallazgoEE",
    subTitulo: "Bandeja de Cobro",
    resource: {
      permiteCambiarDiagnosticador: null,
      idEstatusSolicitud: null,
      arrayDoctorEmbajador: [],
    },
    idEstatusPestañaSeleccionada : 1,
  }),
  methods: {
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {
      this.showAlert();
      this.datosTabla = [];
      this.idEstatusPestañaSeleccionada = intIdEstuatusSolicitud;

      const params = {
        intIdEstuatusSolicitud: intIdEstuatusSolicitud,
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idClinica: this.idClinica,
        idPaciente: this.idPaciente
      }

      this.$http
        .get(
          this.$api +
            "pti/bandeja/cobro/obtenerDatosBandeja", params     )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.resource.idEstatusSolicitud = intIdEstuatusSolicitud; 
          this.datosTabla = response.data.data;
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        }).finally(() => {
          this.getCifrasPorEstatus();
        });
 
    },
    getCifrasPorEstatus() {
      this.showAlert();
      this.$http
        .get(
          this.$api +
            "pti/bandeja/cobro/cifrasPorEstatus?fechaFinal=" +
            this.fechaFin +
            "&fechaIncio=" +
            this.fechaInicio +
            "&idEmpleado=" +
            this.idEmpleado +
            "&idClinica=" +
            this.idClinica +
            "&idPaciente=" +
            this.idPaciente
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;

            data.forEach((elemento) => {
              if (elemento.idEstatusSolicitud == 1) {
                this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[0].layoutTabla = this.encabezadosPendientes;
              }
              if (elemento.idEstatusSolicitud == 2) {
                this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[1].layoutTabla = this.encabezadosEnproceso;
              }
              if (elemento.idEstatusSolicitud == 3) {
                this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[2].layoutTabla = this.encabezadosFinalizados;
              }
            });
          }
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        });
    }, //  ----------------------------


    actualizarFecha(fechaInicio, fechaFin, idPaciente) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.getObtenerDatosBandeja(this.idEstatusPestañaSeleccionada);
    },

        
    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },



  },
  mounted() {
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();

    var dia1 = new Date();
    dia1.setDate(dia1.getDate() - 3);
    dia1.setHours(0, 0, 0, 0);
    this.fechaInicio = this.$moment(dia1)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      
    this.getObtenerDatosBandeja(1);
  },
  computed: {},
};
</script>
